import { useCallback, useEffect, useState } from 'react';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { getAssetUrl } from '@utils/common.utils';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { TableOfContentType } from '../../types';
import TOCModal from '@components/toc-modal';

interface TableOfContentPropType {
  toc: TableOfContentType[];
}

const TableOfContent = ({ toc }: TableOfContentPropType) => {
  const [tocModalOpen, setTocModalOpen] = useState<boolean>(false);

  const openModal = () => {
    setTocModalOpen(true);
  };
  const closeModal = () => {
    setTocModalOpen(false);
  };

  const outsideClickListen = useCallback(
    (e: any) => {
      const isOutsideElem = !(e.target as HTMLElement).closest(
        '.toc-modal-container',
      );
      const isNotOpenButton = !(e.target as HTMLElement).closest(
        '.toc-open-button',
      );
      if (isOutsideElem && isNotOpenButton && tocModalOpen) {
        setTocModalOpen(false);
      }
    },
    [tocModalOpen],
  );

  useEffect(() => {
    document.addEventListener('click', outsideClickListen);
    return () => document.removeEventListener('click', outsideClickListen);
  }, [tocModalOpen, outsideClickListen]);

  return (
    <>
      {toc.length > 0 && (
        <>
          <div
            className={ivclass(
              'toc-open-button',
              'md:iv-w-full sm:iv-w-full',
              'iv-px-10 sm:iv-px-20',
              'md:iv-bg-grey-0 sm:iv-bg-grey-0',
              'md:iv-rounded-xl sm:iv-rounded-xl',
              'md:iv-shadow-toc-middle sm:iv-shadow-toc-middle',
              { 'xl:iv-sticky lg:iv-sticky': !tocModalOpen },
              { 'xl:iv-hidden lg:iv-hidden': tocModalOpen },
              {
                'xl:iv-top-[100px] lg:iv-top-[100px] iv-top-[calc(100vh-11px)]':
                  !tocModalOpen,
              },
            )}
          >
            <div
              className={ivclass(
                'iv-items-center',
                'iv-flex',
                'iv-gap-15 md:iv-gap-[12px] sm:iv-gap-[12px]',
                'md:iv-justify-center',
                'sm:iv-justify-center',
                'md:iv-py-[11px] sm:iv-py-[11px]',
                'md:iv-px-[20px] sm:iv-px-[20px]',
                'md:iv-mb-20 sm:iv-mb-10',
                'iv-cursor-pointer',
                'md:iv-mt-[22px]',
                'iv-bg-grey-0',
              )}
              onClick={openModal}
            >
              <ImageComponent
                elementype="native"
                loading="lazy"
                src={getAssetUrl('blog', '/icons/Left-justify.svg')}
                className={ivclass(
                  'iv-h-[28px] iv-w-[28px]',
                  'md:iv-h-[20px] md:iv-w-[20px]',
                  'sm:iv-h-[20px] sm:iv-w-[20px]',
                )}
              />
              <div
                className={ivclass(
                  'iv-font-bold',
                  'iv-text-blue',
                  'iv-text-heading-2xs iv-m-heading-2xs',
                  'md:iv-text-body-3xl md:iv-m-body-3xl',
                  'sm:iv-text-body-3xl sm:iv-m-body-3xl',
                )}
              >
                Post contents
              </div>
            </div>
          </div>
          {tocModalOpen && (
            <TOCModal
              modalOpen={tocModalOpen}
              toc={toc}
              closeModal={closeModal}
            />
          )}
        </>
      )}
    </>
  );
};

export default TableOfContent;
